import { render, staticRenderFns } from "./FileBox.vue?vue&type=template&id=1b0530d6&scoped=true"
import script from "./FileBox.vue?vue&type=script&lang=js"
export * from "./FileBox.vue?vue&type=script&lang=js"
import style0 from "./FileBox.vue?vue&type=style&index=0&id=1b0530d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0530d6",
  null
  
)

export default component.exports